import React, { useEffect, useRef } from "react";
import "./ViewPhotoSamplePopup.scss";
import correctPhoto from "../../../assets/PhotographSample/correctPhoto.jpg";
import hatCovered from "../../../assets/PhotographSample/hat-covered.svg";
import sunGlass from "../../../assets/PhotographSample/sunglass-covered.svg";
import shadow from "../../../assets/PhotographSample/shadow-covered.svg";
import { useDialogA11y } from "../../UI/Backdrop/Backdrop";

export interface IViewPhotoSamplePopupProps {
  setShowPopup: Function;
  showPopup: boolean;
  text?: any;
  children?: any;
}
const ViewPhotoSamplePopup = (props: IViewPhotoSamplePopupProps) => {
  const closePopup = () => {
    if (props?.setShowPopup !== undefined) props.setShowPopup(false);
  };
  const dialogRef = useDialogA11y(!!props.showPopup, closePopup);
  const overlayRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        overlayRef.current &&
        event.target === overlayRef.current
      ) {
        closePopup();
      }
    };

    const timer = setTimeout(() => {
      document.addEventListener("mousedown", handleClickOutside);
    }, 0);

    return () => {
      clearTimeout(timer);
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [props?.setShowPopup]);

  if (!props.showPopup) {
    return null;
  }

  return (
    <div className="overlay-main" ref={overlayRef}>
      <div
        className="popup-main"
        ref={dialogRef}
        role="dialog"
        aria-modal="true"
        aria-labelledby="photo-sample-popup-title"
      >
        {/* Close Button */}
        <button
          type="button"
          className="close-btn"
          aria-label="Close photo guide"
          onClick={closePopup}
        >
          <i className="edel-icon-close" aria-hidden="true" />
        </button>

        <h2 className="popup-title" id="photo-sample-popup-title">Guide for Photo Upload</h2>

        {/* Popup Content */}
        <div className="grid">
          <div className="box">
            <div className="profile-container">
              <img
                src={correctPhoto}
                alt="Example of a valid clear selfie photo"
                className="profile-image"
              />
              <div className="checkmark" aria-hidden="true">✔</div>
            </div>
            <p className="success">
              Take a selfie facing the camera with a clear background.
            </p>
          </div>

          <div className="box">
            <img src={hatCovered} alt="Invalid photo with hat covering face" height={80} width={120} />
            <p className="error"> Don’t wear a hat.</p>
          </div>

          <div className="box">
            <img src={sunGlass} alt="Invalid photo with sunglasses" height={80} width={120} />
            <p className="error"> Don’t wear sunglasses. </p>
          </div>

          <div className="box">
            <img src={shadow} alt="Invalid dark and blurry photo" height={80} width={120} />
            <p className="error"> Don’t click a dark and blurry photo.</p>
          </div>
        </div>
      </div>
    </div>
  );
};
export default ViewPhotoSamplePopup;
